import React from 'react'
import queryString from 'query-string'

import { removeQueryStringProperty } from 'utils/historyManager'
import { URL_CONST } from 'utils/urlConsts'

import { LOGIN_STEPS } from 'containers/Login/constants'

import CenteredLoader from 'components/lib/CenteredLoader'
import Button from 'components/lib/DesignSystem/Button'
import ErrorMessage from 'components/lib/ErrorMessage'
import Icon from 'components/lib/IconFA'

import Login from './Login'
import TwoFactor from './TwoFactor'

export default class LoginFlow extends React.Component {
  componentDidMount() {
    this.props.validateSession()

    const errorKey = 'error'
    const qs = queryString.parse(this.props.location.search)
    if (qs[errorKey]) {
      const { history } = this.props
      this.props.setError(qs[errorKey])
      removeQueryStringProperty(history, qs, errorKey)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.loginStep !== nextProps.loginStep &&
      nextProps.loginStep === LOGIN_STEPS.LOGGED
    ) {
      this.props.fetchAppData()
    }
    if (nextProps.isAppDataLoaded) {
      const kickoffKey = 'kickoff'
      const url = queryString.parse(this.props.location.search)?.next || ''
      const qs = queryString.parse(queryString.extract(url))

      if (qs[kickoffKey]) {
        this.props.history.push(url)
      } else {
        this.props.history.push(
          nextProps.partner ? URL_CONST.partners.self : URL_CONST.dashboard.home
        )
      }
    }
  }

  render() {
    const {
      error,
      loginStep,

      loginLoader,
      loginSubmitLoader,

      timeTillUnlock,
      tfaParingUrl,
      ssoUrl,

      resetError,

      submitLogin,
      submitExpiredPass,
      submitSSO,

      fetch2FA,
      submit2FA,

      useOtherCredentials,
    } = this.props

    const SubmitButton = ({ text, disabled, onClick, id = 'submit_button' }) => (
      <Button
        text={text}
        id={id}
        className="mt"
        onClick={onClick}
        disabled={disabled}
        loader={loginSubmitLoader}
      />
    )

    let RelevantView
    if (
      loginStep === LOGIN_STEPS.PASSWORD ||
      loginStep === LOGIN_STEPS.PASSWORD_EXPIRED_STEP ||
      loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA ||
      loginStep === LOGIN_STEPS.SSO_ENFORCEMENT
    ) {
      RelevantView = (
        <Login
          loginStep={loginStep}
          ssoUrl={ssoUrl}
          loginSubmitLoader={loginSubmitLoader}
          resetError={resetError}
          submitLogin={submitLogin}
          submitExpiredPass={submitExpiredPass}
          submitSSO={submitSSO}
          SubmitButton={SubmitButton}
        />
      )
    } else if (
      loginStep === LOGIN_STEPS.TFA_TOKEN_STEP ||
      loginStep === LOGIN_STEPS.TFA_PAIRING_STEP
    ) {
      RelevantView = (
        <TwoFactor
          loginStep={loginStep}
          tfaParingUrl={tfaParingUrl}
          fetch2FA={fetch2FA}
          submit2FA={submit2FA}
          SubmitButton={SubmitButton}
        />
      )
    } else if (loginStep === LOGIN_STEPS.USER_PASSWORD_BLOCK_STEP) {
      RelevantView = (
        <>
          You have been blocked, try again in
          {` ${timeTillUnlock} minutes`}
        </>
      )
    } else if (loginStep === LOGIN_STEPS.LOGGED) {
      // allocate space for loader while AppData is loading
      RelevantView = <div style={{ padding: '50px' }} />
    }

    return (
      <div className="login-form floating-form">
        {error && <ErrorMessage marginBottom="15px">{error?.detail}</ErrorMessage>}

        {RelevantView}

        {[
          LOGIN_STEPS.PASSWORD_EXPIRED_STEP,
          LOGIN_STEPS.TFA_TOKEN_STEP,
          LOGIN_STEPS.TFA_PAIRING_STEP,
          LOGIN_STEPS.USER_PASSWORD_BLOCK_STEP,
        ].includes(loginStep) && (
          <div className="inline-button" onClick={useOtherCredentials}>
            <Icon name="angle-left" marginRight="5px" />
            Use other credentials
          </div>
        )}

        <div className="privacy-police">
          By logging in you agree to our{' '}
          <a target="_blanc" href="/privacy-police/">
            Privacy Policy
          </a>
        </div>

        {loginLoader && <CenteredLoader overlap overlapMargin="15" />}
      </div>
    )
  }
}
